import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import './style.css';



function Sidebar({showSidebar}:{showSidebar:boolean}) {
    const [sidebarClass, setSidebarClass] = useState('')
    
    useEffect(()=>{
        setSidebarClass(` ${showSidebar ? 'show-res-sidebar' : 'hoc-sidebar'}`)
    },[showSidebar]);

  return (
    <div className={sidebarClass}>
        <h2 className='sub-header'>Components</h2>
        <div className='component-list'>

            <Link to="/input">
                <span className="component-link">Input</span>
            </Link>
            <div className="line" />
            <Link to="/rating">
                <span className="component-link">Rating</span>
            </Link>
            <div className="line" />
            <Link to="/toast">
                <span className="component-link">Toast</span>
            </Link>
            <div className="line" />
            <Link to="/button">
                <span className="component-link">Button</span>
            </Link>
            <div className="line" />
            <Link to="/drawer">
                <span className="component-link">Drawer</span>
            </Link>
            <div className="line" />
            <Link to="/modal">
                <span className="component-link">Modal</span>
            </Link>
            <div className="line" />
            <Link to="/tooltip">
                <span className="component-link">Tooltip</span>
            </Link>
            {/* <div className="line" /> */}
        
        </div>
    </div>
  )
}

export default Sidebar